import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

import UniversalSearch from '../UniversalSearch';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

/**
 * The search sheet for narrow screens, where the nav bar has no room for the
 * search field itself.
 *
 * It hosts the SAME component as the nav bar rather than a second input, so
 * there is one search behaviour to reason about. Its predecessor rendered a
 * decorative field that was wired to nothing: no state, no submit — typing in
 * it and pressing the magnifying glass just closed the dialog.
 *
 * `zIndex` is above the app bar (which sits at drawer + 1). The old value was
 * a literal `1`, which put this sheet UNDERNEATH the very bar that opens it,
 * so even once something did open it, it was invisible.
 */
export default function SearchDialog({ open, handleClose }) {
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
      slotProps={{
        paper: {
          sx: { position: 'fixed', top: 16, m: 0, borderRadius: 3, alignSelf: 'flex-start' },
        },
      }}
    >
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            Search Vhakacha
          </Typography>
          <IconButton size="small" onClick={handleClose} aria-label="Close search">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        {/* Closes on submit — leaving the sheet covering the results it just
            produced is the one thing it must not do. */}
        <UniversalSearch autoFocus onSubmitted={handleClose} sx={{ maxWidth: 'none' }} />
      </Box>
    </Dialog>
  );
}
